import React from 'react'
import { StopImages } from '../../../desktop/stop/StopImages'

export const Photos = ({ handleOpenPhoto }) => {
  return (
    <StopImages handleOpenPhoto={handleOpenPhoto} />
  )
}
